import { render, staticRenderFns } from "./MessagesByGroup.vue?vue&type=template&id=ed5b1d80&"
import script from "./MessagesByGroup.vue?vue&type=script&lang=js&"
export * from "./MessagesByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports